// src/services/teamService.js
import api from './api'; 

const teamService = {
  // GET /api/empresas/time/
  getMembers: () => {
    return api.get('/empresas/time/');
  },

  // POST /api/empresas/convidar/
  inviteMember: (email) => {
    return api.post('/empresas/convidar/', { email });
  },

  // DELETE /api/empresas/time/{id}/
  removeMember: (memberId) => {
    return api.delete(`/empresas/time/${memberId}/`);
  },

   acceptInvitation: (formData) => {
    // formData deve ser um objeto com:
    // { token, nome_completo, password, cpf, telefone }
    return api.post('/empresas/aceitar-convite/', formData);
  },

  getInvitationDetails: (token) => {
    return api.get(`/empresas/convites/${token}/`);
  }
};

export default teamService;